import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchBarComponent implements OnInit, OnDestroy {
  query: string;
  private destroy$: Subject<void> = new Subject<void>();
  searchForm: FormGroup = this.fb.group({
    searchTerm: '',
  });

  @Input() set searchQuery(value) {
    if (this.searchForm) {
      this.searchForm.patchValue({ searchTerm: value });
    }
  }
  @Input() placeholder = '';
  @Input() hint = '';
  @Input() minLength = 3;
  @Output() handleSearch = new EventEmitter<string>();

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.searchForm.valueChanges
      .pipe(debounceTime(500), takeUntil(this.destroy$))
      .subscribe((value) => {
        const query = value.searchTerm;

        if (query.length === 0 || query.length >= this.minLength) {
          this.handleSearch.emit(query);
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
  }
}
